import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body, Container, H5, Page } from '@ui';
import { useNavigate } from 'react-router';
import { scrollToTop } from '@utils/usefulFuncs';
import { ROUTES } from '@constants/routes';
import { TemplateProcessorTool } from '@/features/rfp/TemplateProcessorTool';
import { AI_TOOLS, DOCUMENT_TEMPLATE_MODE_IDS } from '@/constants';
import { DOCUMENT_SELECTION_MODES } from '@/features/document/DocumentSelectionModal/modes';

const PageWrapper = styled.div`
  + div {
    width: 100%;
  }
`;

const modeContext = {
  tool: AI_TOOLS.DOC_TEMPLATE_PROCESSOR,
  modeType: DOCUMENT_TEMPLATE_MODE_IDS.doc_template_processor,
  autoSelectDefaultDocuments: true,
  showCompanyTags: true,
  documentSelectionModes: [DOCUMENT_SELECTION_MODES.myUploads, DOCUMENT_SELECTION_MODES.company],
  defaultActiveDocumentSelectionMode: DOCUMENT_SELECTION_MODES.myUploads,
};

export function DocumentTemplateProcessorPage() {
  const navigate = useNavigate();
  const isStreamingEnabled = false;

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page width={'1800px'}>
          <Container top={40}>
            <H5>Report Document Generator</H5>
          </Container>
          <Container top={24}>
            <TemplateProcessorTool
              onGoBack={onGoBack}
              isStreamingEnabled={isStreamingEnabled}
              modeContext={modeContext}
            />
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
}
